const TwoArrowConnection = () => {
  return (
    <div className="flex justify-center gap-10">
      {/* Left Connection */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="372"
        height="120"
        viewBox="0 0 372 120"
        fill="none"
      >
        <path
          d="M369.5 2.5V32.6087C369.5 45.8635 358.755 56.6087 345.5 56.6087H26.5C13.2452 56.6087 2.5 67.3538 2.5 80.6087V153.5"
          stroke="url(#leftGradient)"
          strokeWidth="5"
          strokeLinecap="square"
        />

        <defs>
          <linearGradient
            id="leftGradient"
            x1="2.50001"
            y1="153.5"
            x2="85.2985"
            y2="-92.9728"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#DFDFDF">
              <animate
                attributeName="offset"
                values="1;-1"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="50%" stopColor="#2D65F2">
              <animate
                attributeName="offset"
                values="2;0"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="100%" stopColor="#FFFFFF">
              <animate
                attributeName="offset"
                values="3;1"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      </svg>

      {/* Right Connection */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="372"
        height="120"
        viewBox="0 0 372 120"
        fill="none"
      >
        <path
          d="M2.5 2.5V32.6087C2.5 45.8635 13.2452 56.6087 26.5 56.6087H345.5C358.755 56.6087 369.5 67.3538 369.5 80.6087V153.5"
          stroke="url(#rightGradient)"
          strokeWidth="5"
          strokeLinecap="square"
        />

        <defs>
          <linearGradient
            id="rightGradient"
            x1="369.5"
            y1="153.5"
            x2="286.76"
            y2="-92.9385"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#DFDFDF">
              <animate
                attributeName="offset"
                values="1;-1"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="50%" stopColor="#2D65F2">
              <animate
                attributeName="offset"
                values="2;0"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="100%" stopColor="#FFFFFF">
              <animate
                attributeName="offset"
                values="1;3"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default TwoArrowConnection;
